export default __webpack_public_path__ + "static/media/692.d6648c44.png";